import { useEffect, useMemo, useState } from "react";
import "./SatisfiedClients.scss";
import { Container, useMediaQuery } from "@mui/material";
import { FreeMode, Navigation, Pagination } from "swiper/modules";
import SwiperNavButton from "../SwiperNavButton";
import { Swiper, SwiperSlide } from "swiper/react";
import SliderCart from "./SliderCart";
import { fetchReviews } from "../../utils/reviews";
import CustomLoader from "../Shared/CustomLoader/CustomLoader";
import { CustomLoaderType } from "../../utils/constants";
import { useGetTestimonialsQuery } from "../../utils/API/features/strapiHomeApi";

const SatisfiedClients = () => {
	const matches = useMediaQuery("(max-width:1200px)");

	const [googleReviews, setGoogleReviews] = useState([]);

	const shouldUseStrapi = Boolean(import.meta.env.VITE_STRAPI_URL);

	const {
		data: strapiTestimonials = [],
		isLoading,
		isFetching,
		isError,
	} = useGetTestimonialsQuery(undefined, {
		skip: !shouldUseStrapi,
	});

	const isBusy = shouldUseStrapi && (isLoading || isFetching);

	const reviews = useMemo(() => {
		const strapi = !isError && strapiTestimonials?.length > 0 ? strapiTestimonials : [];
		return [...strapi, ...(googleReviews ?? [])];
	}, [googleReviews, isError, strapiTestimonials]);

	const handleReview = () => {
		window.open(
			"https://www.google.com/maps/place/Valley+Plumbing,+Heating+%26+Water+Treatment/@44.9691733,-76.231041,17z/data=!4m8!3m7!1s0x4cd271a0b11cd089:0x6017ba108c0236fc!8m2!3d44.9691695!4d-76.2284661!9m1!1b1!16s%2Fg%2F11bc8cyzdk?entry=ttu",
			"_blank",
		);
	};

	useEffect(() => {
		const getReviews = async () => {
			const r = await fetchReviews();

			setGoogleReviews(r);
		};

		getReviews();
	}, []);

	if (!isBusy && reviews.length === 0) return null;
	return (
		<div className='satisfied-clients-wrapper'>
			<Container>
				<Swiper
					slidesPerView={matches ? 1.1 : 2.5}
					spaceBetween={matches ? 20 : 50}
					modules={[Navigation, FreeMode, Pagination]}
					navigation={true}
					className={`mySwiper`}
					style={{ paddingTop: "160px" }}
					freeMode={true}
					speed={800}
				>
					<div className='top-section'>
						<div className='top-buttons'>
							<div className='header'>
								<p>Testimonials</p>
								<h1>Hear It From Our Satisfied Clients</h1>
								<button className='white-button' onClick={handleReview}>
									Write a Review
								</button>
							</div>
							<div className='nav-buttons'>
								<SwiperNavButton />
							</div>
						</div>
					</div>
					{isBusy ? (
						<SwiperSlide>
							<CustomLoader type={CustomLoaderType.SMALL} />
						</SwiperSlide>
					) : null}
					{reviews.map((cart, index) => (
						<SwiperSlide key={index}>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									flexDirection: "column",
									gap: "24px",
									width: "100%",
									background: "#F2F0EE",
								}}
							>
								<SliderCart data={cart} />
							</div>
						</SwiperSlide>
					))}
					{matches && (
						<div className='nav-buttons'>
							<SwiperNavButton whiteButtons={true} />
						</div>
					)}
				</Swiper>
			</Container>
		</div>
	);
};

export default SatisfiedClients;
